import React from 'react';
import { getUser } from '../../shared/auth-service';
import ContentLASA from './Company/contentLasa';
import ContentSAI from './Company/contentSAI';
import ContentEcuador from './Company/contentEcuador';

const Home = () => {
  const user = getUser();
  const companyId = user.countryCode.split('-')[0];

  switch (companyId) {
    case "1":
      return <ContentLASA user={user} />;
    case "2":
      return <ContentSAI user={user} />;
    case "3":
      return <ContentEcuador user={user} />;
    default:
      return null; // No muestra nada
  }
};

export default Home;
